var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tabsContent",staticClass:"tabs-content tw-flex tw-items-start",staticStyle:{"z-index":"1"},style:([{height: _vm.height}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }